var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ebp-multiselect"},[_c('multiselect',_vm._g(_vm._b({},'multiselect',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }